<template>
  <a-modal v-model:visible="visible" title="达到上限" :width="877" min-height>
    <a-alert message="表盘配色数量已到达上限值，无法新增配色！" type="error">
      <template #description>
        <div>
          1. 单个样式配色色值不可超过{{ GlobalConfig.themeColorMax }}个；
        </div>
        <div>
          2. 表盘整体配色色值不可超过{{ GlobalConfig.themeColorMax }}个；
        </div>
      </template>
    </a-alert>
    <a-table
      :columns="columns"
      :data-source="records"
      :pagination="false"
      :scroll="{
        y: 450
      }"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'colors'">
          <!-- <span
            v-for="color in record.colors"
            :key="color"
            class="mr-2"
            :style="{}"
          >
            {{ color }}
          </span> -->
          {{ record['colors']?.length ?? 0 }}
        </template>
        <template v-if="column.dataIndex === 'isOverLimit'">
          <span v-if="record['isOverLimit']" class="text-red-500">
            达到上限</span
          >
          <span v-else>否</span>
        </template>
      </template>
    </a-table>
    <template #footer>
      <a-button type="back" class="!mt-2.5" @click="close"> 关闭 </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { GlobalConfig } from '@/services/gloabl.config';
import { useLayerStore } from '@/store/use-layer-store';
import { computed, ref } from 'vue';

const layerStore = useLayerStore();

const columns = [
  {
    title: '所属样式',
    dataIndex: 'themeName'
  },
  {
    title: '色值数量',
    dataIndex: 'colors'
  },
  {
    title: '允许上限（个）',
    dataIndex: 'limit'
  },
  {
    title: '达到上限',
    dataIndex: 'isOverLimit'
  }
];

const visible = ref(false);
const open = async () => {
  visible.value = true;
};
defineExpose({ open });

const records = computed(() => {
  const res: {
    themeName: string;
    colors: string[];
    limit: number;
    isOverLimit: boolean;
  }[] = [];

  const colorsWhole: string[] = [];
  layerStore.themes.forEach((theme) => {
    const colors = theme.colorGroupTable.map((item) => item.color);
    colorsWhole.push(...colors);
    res.push({
      themeName: theme.name,
      colors,
      limit: GlobalConfig.themeColorMax,
      isOverLimit: colors.length >= GlobalConfig.themeColorMax
    });
  });
  // 表盘整体
  const colorsWhole2 = [...new Set(colorsWhole)];
  res.push({
    themeName: '表盘整体',
    colors: colorsWhole2,
    limit: GlobalConfig.themeColorMax,
    isOverLimit: colorsWhole2.length >= GlobalConfig.themeColorMax
  });
  return res;
});

const close = () => {
  visible.value = false;
};
</script>
<style lang="less"></style>
